import { Component, OnInit, Input } from "@angular/core";
import { SportType } from "src/app/model/sport-type.model";
import { InstructorService } from "src/app/service/instructor.service";
import { Instructor } from "src/app/model/instructor.model";
import { MatDialog } from "@angular/material";
import { DeleteConfirmationDialog } from "../../delete-confirmation/delete-confirmation.dialog";
import { DataService } from "src/app/service/data.service";

@Component({
  selector: "app-sport-type",
  templateUrl: "./sport-type.component.html",
  styleUrls: ["./sport-type.component.css"]
})
export class SportTypeComponent implements OnInit {
  @Input() instructor: Instructor;
  canRemove = true;
  sportTypes: SportType[];
  selectedSportType: SportType;

  constructor(
    public dialog: MatDialog,
    private instructorService: InstructorService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.dataService.getSportTypes().subscribe(data => {
      this.sportTypes = data as SportType[];
    });
  }

  getSportTypes(): SportType[] {
    return this.sportTypes.filter(
      item => !this.instructor.sportTypes.some(st => st.id === item.id)
    );
  }

  remove(sportType: SportType) {
    const index = this.instructor.sportTypes.indexOf(sportType, 0);
    if (index > -1) {
      const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
        width: "300px",
        data: {
          title: `DELETE ${sportType.name}`,
          message: `Are you sure you want to remove ${sportType.name}`,
          key: "",
          enterKeyToConfirm: false
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (this.instructor.user.id === 0) {
            const i = this.instructor.sportTypes.indexOf(sportType, 0);
            if (i > -1) {
              this.instructor.sportTypes.splice(i, 1);
            }
          } else {
            this.instructorService
              .deleteSportType(this.instructor.user.id, sportType.id)
              .subscribe(data => {
                if (data) {
                  this.instructor.sportTypes = data as SportType[];
                }
              });
          }
        }
      });
    }
  }

  add(sportTypeSelectRef) {
    const dialogRef = this.dialog.open(sportTypeSelectRef, {
      width: "250px"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.selectedSportType != null) {
        if (this.instructor.user.id > 0) {
          this.instructorService
            .addSportType(this.instructor.user.id, this.selectedSportType.id)
            .subscribe(data => {
              if (data) {
                this.instructor.sportTypes = data as SportType[];
                this.selectedSportType = null;
              }
            });
        } else {
          this.instructor.sportTypes.push(this.selectedSportType);
          this.selectedSportType = null;
        }
      }
    });
  }
}
